import React from 'react';
import PropTypes from 'prop-types';
import './ErrorAlert.css';
import { Alert, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ErrorAlert = ({ message, onClose }) => (
  <div className="error-alert" role="alert">
    <div className="alert-content">
      <Alert
        severity="warning"
        action={(
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
      )}
      >
        <h2 className="alert-title">Oops! Something went wrong</h2>
        <p className="alert-message">
          The application has encountered an error. Here is the error message received:
          {' '}
          {message}
        </p>
      </Alert>
    </div>
  </div>
);

ErrorAlert.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ErrorAlert;
